// import logo from './logo.svg';
import './App.css';
import Hero from './Hero';

function App() {
  return (
    <div>
      <Hero/>
    </div>
  );
}

export default App;
